import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getCurrentUser, hasRole, hasSafeAccess, logout } from "../utils/api";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const user = getCurrentUser();
    const { t } = useTranslation();

    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    // Geen header op login/register-pagina's
    if (
        location.pathname === "/" ||
        location.pathname === "/login" ||
        location.pathname === "/register"
    ) {
        return null;
    }

    return (
        <nav className={`home-navbar ${hasRole("owner") ? "home-navbar--owner" : ""}`}>
            <div className="home-brand">
                <div className="home-logo-text">EliteHome</div>
            </div>

            {/* === Hamburger menu knop === */}
            <button
                type="button"
                className={`nav-toggle ${menuOpen ? "open" : ""}`}
                aria-label="Toggle navigation"
                onClick={() => setMenuOpen(!menuOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            {/* === Desktop navigatie === */}
            <ul className="nav-desktop">
                {!hasRole("owner") && <li><Link to="/home">{t("nav.home")}</Link></li>}
                {hasRole("owner") && <li><Link to="/owner">{t("nav.myDashboard")}</Link></li>}
                {!hasRole("owner") && <li><Link to="/apartments">{t("nav.apartments")}</Link></li>}
                {!hasRole("owner") && <li><Link to="/invoices">{t("nav.invoices")}</Link></li>}
                {!hasRole("owner") && <li><Link to="/financial">{t("nav.financial")}</Link></li>}
                {hasSafeAccess() && <li><Link to="/safe">{t("nav.safe")}</Link></li>}
                {hasRole("admin") && <li><Link to="/admin">{t("nav.admin")}</Link></li>}
            </ul>

            <div className="nav-actions">
                <LanguageSwitcher />
                <button className="btn-secondary nav-logout" onClick={handleLogout}>
                    {t("nav.logout")}
                </button>
            </div>

            {/* === Mobiel menu === */}
            {menuOpen && (
                <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}>
                    <div className="mobile-menu glass" onClick={(e) => e.stopPropagation()}>
                        <ul>
                            {!hasRole("owner") && <li><Link to="/home" onClick={() => setMenuOpen(false)}>{t("nav.home")}</Link></li>}
                            {hasRole("owner") && <li><Link to="/owner" onClick={() => setMenuOpen(false)}>{t("nav.myDashboard")}</Link></li>}
                            {!hasRole("owner") && (
                                <>
                                    <li><Link to="/apartments" onClick={() => setMenuOpen(false)}>{t("nav.apartments")}</Link></li>
                                    <li><Link to="/invoices" onClick={() => setMenuOpen(false)}>{t("nav.invoices")}</Link></li>
                                    <li><Link to="/financial" onClick={() => setMenuOpen(false)}>{t("nav.financial")}</Link></li>
                                    {hasSafeAccess() && <li><Link to="/safe" onClick={() => setMenuOpen(false)}>{t("nav.safe")}</Link></li>}
                                </>
                            )}
                            {hasRole("admin") && <li><Link to="/admin" onClick={() => setMenuOpen(false)}>{t("nav.admin")}</Link></li>}
                            <li>
                                <LanguageSwitcher onAfterChange={() => setMenuOpen(false)} />
                            </li>
                            <li><button className="btn-secondary" onClick={handleLogout}>{t("nav.logout")}</button></li>
                        </ul>
                    </div>
                </div>
            )}
        </nav>
    );
}
